/**
 * Initializes the mobile navigation menu.
 * This function adds a click event listener to the menu toggle button
 * to show/hide the mobile navigation menu and update the document class accordingly.
 */
function initNavMenu() {
  const mobileNav = document.querySelector('.wp-block-bitesize-mobile-navigation');

  // If there's no nav menu, none of this is necessary.
  if (!mobileNav) {
    return;
  }

  const menuToggle = mobileNav.querySelector('.wp-block-bitesize-mobile-navigation__toggle');

  menuToggle.addEventListener('click', () => {
    mobileNav.classList.toggle('is-open');
    document.documentElement.classList.toggle(
      'is-mobile-menu-open',
      mobileNav.classList.contains('is-open'),
    );
  });
}

/**
 * Sets up the sticky navigation behavior.
 * This function adds scroll and resize event listeners to update the header's
 * sticky class based on the scroll position.
 */
function stickyNav() {
  const secondaryHeader = document.querySelector('.wp-block-bitesize-secondary-header');
  let secondaryHeaderHeight = secondaryHeader.clientHeight;
  const header = document.querySelector('.wp-block-bitesize-header');
  const headerWrapper = document.querySelector('.wp-block-bitesize-header-wrapper');

  // Set the initial min-height of headerWrapper
  headerWrapper.style.minHeight = `${headerWrapper.clientHeight}px`;

  /**
   * Update Heights
   * This function updates the height variables when needed.
   */
  function updateHeights() {
    secondaryHeaderHeight = secondaryHeader.clientHeight;
    headerWrapper.style.minHeight = `${headerWrapper.clientHeight}px`;
  }

  /**
   * Handles the scroll event.
   * This function checks the scroll position and updates the header's sticky class accordingly.
   */
  function handleScroll() {
    const scrollPosition = window.scrollY || window.pageYOffset;
    header.classList.toggle(
      'wp-block-bitesize-header--stuck',
      scrollPosition > secondaryHeaderHeight,
    );
  }

  window.addEventListener('scroll', handleScroll);

  // Add an event listener for the resize event to recalculate heights
  window.addEventListener('resize', updateHeights);
}

/**
 * Initializes the navigation menu and sticky navigation when the window is loaded.
 */
window.addEventListener('load', () => {
  initNavMenu();
  stickyNav();
});
